<template>
  <v-dialog
    :key="data.dialogaddprofile"
    v-model="data.dialogaddprofile"
    width="500"
    content-class="elevation-0 rounded-xl"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        v-bind="attrs"
        v-on="on"
        block
        elevation="0"
        class="text-center mt-4"
        text
        color="primary"
      >
        Profiel toevoegen
      </v-btn>
    </template>

    <v-card
      elevation="0"
      class="h-100 py-5 px-2 pa-md-10 rounded-xl"
      color="white align-center"
    >
      <div class="d-flex">
        <v-btn
          color="primary"
          class="position-absolute"
          icon
          text
          @click="data.dialogaddprofile = false"
        >
          <v-icon color="primary">fal fa-times</v-icon></v-btn
        >
      </div>

      <h4
        v-text="'Profielen koppelen'"
        color="primary"
        class="
          headline
          font-weight-bold
          text-center
          mx-auto
          d-block
          text-primary
          mb-2
        "
      ></h4>

      <p class="text-center">
        Selecteer de profielen die wilt koppelen aan deze Card. Of maak een
        nieuw profiel aan.
      </p>

      <v-select
         v-model="data.select"        
          :items="data.profiles"  
        :menu-props="{ maxHeight: '400' }"
         item-text="name"
          item-value="id"
        label="Selecteer profielen"
        multiple
        outlined
        return-object
        hint="Meerdere profielen selecteren is mogelijk."
        persistent-hint
      ></v-select>
   
      <v-spacer class="my-10"></v-spacer>

      <v-btn 
      v-if="data.select"  
        large    
        block
        elevation="0"
        class="text-center my-4"
        color="secondary"
      >
        Geselecteerde profielen toevoegen
      </v-btn>
      <v-btn       
        color="secondary"
        class="my-4"
        large        
        block
        elevation="0"
        to="/profiles/create"
      >
        Profiel aanmaken
      </v-btn>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  props: {
    data: Object
  },
  data() {
    return {
      selectprofile: null,
     
      rules: {
        required: (value) => !!value || "Verplicht.",
        min: (v) => v.length >= 8 || "Min 8 tekens",
        emailMatch: () => `The email and password you entered don't match`,
      },
    };
  },
};
</script>

